import { cliSimpleGit } from './cli-simple-git.js';

export async function getRemoteOriginUrl(gitDir: string): Promise<string> {
  try {
    const git = cliSimpleGit(gitDir);
    const out = await git.raw(['config', '--get', 'remote.origin.url']);
    return String(out).trim();
  } catch {
    return '';
  }
}
